import Icon from '../components/Icon.vue'

Icon.register({"chart-pie":{"width":576,"height":512,"paths":[{"d":"M288 12.3V240H515.7C522.6 240 528 234.2 527.7 227.3 521.3 104.9 423.2 6.7 300.7 0.3 293.8 0 288 5.4 288 12.3zM552.7 288C559.6 288 565 293.8 564.7 300.7 561.9 353.9 541.5 406.3 503.5 448.5 498.9 453.6 490.9 453.9 486 449L325 288H552.7zM401 433C405.8 437.8 405.7 445.8 400.6 450.3 358 488.7 301.6 512 239.8 512 107.6 511.9-0.2 403.8 0 271.5 0.2 143.4 100.8 38.9 227.3 32.3 234.2 31.9 240 37.4 240 44.3V272L401 433z"}]}})



// WEBPACK FOOTER //
// ./node_modules/vue-awesome/icons/chart-pie.js